import { Heading } from "@/ui/cva/Heading";

type ProductDetailsPanelTitleProps = {
  children: string | JSX.Element;
};

export const ProductDetailsPanelTitle = ({
  children,
}: ProductDetailsPanelTitleProps) => {
  if (typeof children === "string") {
    return (
      <Heading className="flex-1" as="h5">
        {children}
      </Heading>
    );
  }

  return children;
};
